if (typeof JW === 'undefined') JW = {};
JW.MapSForm = (function ($)
{
    var _pri = {opts:{}};
    var publ = {};

    _pri.cname  = 'MAPSFORM';
    _pri.inited = false;

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.initVals = function()
    {
        _pri.opts = $.extend(_pri.opts,
                    {
                        dist_start_val: 25,       // fallback value for distance slider - change sphere_mask.radius in jw.map too
                        dist_init_val: 25,        // init value for distance slider - filled by quest object or fallback
                        hired_start_val: '07',    // star val if quest object's hired is empty
                        get_jobs_url: '/_jss/ssl' //'/jss/sjs' // search stand locs url
                    });

        _pri.page = null;
        _pri.$frm = null;
        _pri.dist_slider = null;
        _pri.dist_buff = -1;
        _pri.$loc_inp = null;
        _pri.loc_buff = null;
        _pri.$dist_inp = null;        // dist slider input
        _pri.emp_tags_select = null;  // tags select
        _pri.$hired_btng = null;
        _pri.$lnk_locate = null;
        _pri.$lnk_reset = null;
        //_pri.job_scope_select = null; // job scope select
        _pri.sbtn_html = '<i class="fa fa-search fa-fw" aria-hidden="true"></i><span class="sr-only">Jobs suchen</span>';
        _pri.sbtn_html_load = '<i class="fa fa-refresh fa-spin fa-fw" aria-hidden="true"></i><span class="sr-only">Daten werden geladen</span>';
        _pri.$sbtn = null;
        _pri.$col = null;
        _pri.qo = null;               // quest object
        _pri.jobs_cache = {};

        _pri.inited_hired = false;
        _pri.inited_advanced = false;

        _pri.$col        = $('#col-left');
        _pri.$frm        = $('#sform');

        _pri.$sbtn       = $('#qs');
        _pri.$loc_inp    = $('#ql');
        _pri.$dist_inp   = $('#qd');
        _pri.$hired_inp  = _pri.$frm.find('input[name="emp_prof_hired"]');
        _pri.$hired_btng = _pri.$frm.find('.hired-btns');
        _pri.$lnk_locate = $('#lnk-locate');
        _pri.$lnk_reset  = $('#sreset');
    };

    publ.init = function()
    {
        _pri.dbgG('*** init()');

        if (_pri.inited)
        {
            _pri.dbgB('    already inited');
            // return;
        }

        _pri.initVals();

        _pri.page = JW.Page;


        if (_pri.$frm.length == 0)
        {
            _pri.dbg('    no #form - exit');
            _pri.$frm = null;
            return;
        }

        _pri.qo = _pri.$frm.data('qo');
        _pri.dbg('_pri.qo: ', _pri.qo);
        if (typeof _pri.qo !== 'object')
        {
            _pri.qo = {loc: '', emp_prof0: '', emp_prof1: '', emp_prof_hired: _pri.opts.hired_start_val, emp_tags: '', lat: 0, lng: 0, dist: _pri.opts.dist_start_val};
        }

        _pri.initFormByQo();

        _pri.initDistSlider();
        _pri.initTagsSelect();
        _pri.initAdvSearch();
        _pri.initHiredBtns();
        _pri.initFfx();

        _pri.initEvs();

        /*
        _pri.job_scope_select = JW.JBSelect(jQuery, document.getElementsByClassName("jb-select job-scope"));
        _pri.job_scope_select.on('jbselect:val_changed', function(e) {
            _pri.dbg('******** job-scope on jbselect:val_changed');
            _pri.getJobs();
        });
        */

        _pri.inited = true;
        _pri.page.trigger('module:init_done', {mod: _pri.cname});
    };

    publ.initQuest = function()
    {
        if (_pri.qo != null && typeof _pri.qo.lat !== 'undefined' && typeof _pri.qo.lng !== 'undefined' && typeof _pri.qo.loc !== 'undefined' && _pri.qo.loc != '')
        {
            _pri.page.trigger('geoc:set_ll_to_name_done', {nm: _pri.qo.loc, ll: L.latLng(_pri.qo.lat, _pri.qo.lng)});
        }
        else
        {
            JW.GeoC.locate();
        }
    };

    publ.tests = function()
    {
        _pri.getFormData();
    };

    _pri.getFormData = function()
    {
        _pri.dbg('******** getFormData()');

        //_pri.dbg(_pri.$frm.serialize());
        //_pri.dbg(_pri.$frm.serializeArray());

        var form_data = {};
        var arr = _pri.$frm.serializeArray();
        var len = arr.length;
        var i, o;
        for (i = 0; i < len; ++i)
        {
            o = arr[i];
            if (o.name === 'emp_tags')
            {
                continue;
            }

            if (!form_data.hasOwnProperty(o.name))
            {
                form_data[o.name] = o.value.toString();
            }
            else
            {
                form_data[o.name] += ',' + o.value.toString();
            }
        }

        //we need the values here
        var map = _pri.emp_tags_select.getItemsMap();
        //_pri.dbg('map', map);
        var ks = Object.keys(map);
        len = ks.length;
        if (ks.length > 0)
        {
            for (i = 0; i < len; ++i)
            {
                if (i == 0)
                {
                    form_data['emp_tags'] = encodeURIComponent(map[ks[i]].txt);
                }
                else
                {
                    form_data['emp_tags'] += ',' + encodeURIComponent(map[ks[i]].txt); // no nneed for escaping ',' because input has already been split by ','
                }
            }
        }
        //_pri.dbg(form_data);
        return form_data;
    };

    publ.getDist = function()
    {
        var dist = parseInt(_pri.$dist_inp.val());
        if (dist < 1)
        {
            dist = 1;
        }
        else if (dist > 100)
        {
            dist = 100;
        }
        return dist;
    }

    _pri.isLocBufNm = function(nm)
    {
        if (_pri.isObj(_pri.loc_buff) && _pri.loc_buff.hasOwnProperty('nm') && _pri.loc_buff.nm == nm)
        {
            return true;
        }
        return false;
    };

    _pri.formSubmit = function(e)
    {
        e.preventDefault();
        _pri.dbg('******** formSubmit()');
        _pri.$loc_inp.blur();

        var locstr = _pri.$loc_inp.val();
        if (locstr != '')
        {
            if (_pri.isLocBufNm(locstr))
            {
                _pri.page.trigger('sform:formSubmit_for_ll', _pri.loc_buff.ll);
                _pri.getJobs();
            }
            else
            {
                JW.GeoC.getLLToName(locstr);
            }
        }

        return false;
    };

    publ.getJobsToKey = function(k)
    {
        if (_pri.jobs_cache.hasOwnProperty(k))
        {
            return _pri.jobs_cache[k];
        }
        return null;
    }

    _pri.getJobs = function()
    {
        var form_data = _pri.getFormData();

        _pri.dbgG('*** getJobs() form_data: ', form_data);

        var pat = /^[1-9]\d*$/;
        if (form_data.ql != '' && _pri.isLocBufNm(form_data.ql) && pat.test(form_data.qd))
        {
            _pri.page.trigger('sform:loading_jobs');
            form_data.lat = _pri.loc_buff.ll.lat;
            form_data.lng = _pri.loc_buff.ll.lng;

            $.ajax({
                type: "POST",
                url: _pri.opts.get_jobs_url + '?tkn=' + JW.Page.getUId(32),
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                data: form_data,
                dataType: 'json'
            }).done(function(ret, stat_str, jq_xhr) {
                _pri.dbg('*** getJobs() done ret:', ret);

                var jobs_cache_key = JW.Page.getUId();
                _pri.jobs_cache = {};
                _pri.jobs_cache[jobs_cache_key] =
                {
                    jobs: ret,
                    lat: form_data.lat,
                    lng: form_data.lng,
                    dst: form_data.qd
                };
                _pri.page.trigger('sform:loading_jobs_done', {key: jobs_cache_key});
            });
        }
    };

    _pri.locate = function(e)
    {
        if ('' == _pri.$loc_inp.val() || _pri.sbtn_html != _pri.$sbtn.html())
        {
            return false;
        }


        if (typeof e !== 'undefined')
        {
            e.preventDefault();
        }

        JW.GeoC.locate();
    };

    _pri.resetForm = function(e)
    {
        /**/
        if ('' == _pri.$loc_inp.val() || _pri.sbtn_html != _pri.$sbtn.html())
        {
            return false;
        }


        if (typeof e !== 'undefined')
        {
            e.preventDefault();
        }

        _pri.$loc_inp.val('');
        _pri.qo.dist = _pri.opts.dist_start_val;
        _pri.qo.loc = '';
        _pri.qo.lat = 0;
        _pri.qo.lng = 0;
        _pri.qo.emp_prof_hired = _pri.opts.hired_start_val;
        _pri.qo.emp_tags = '';
        _pri.qo.emp_prof0 = '';
        _pri.qo.emp_prof1 = '';

        _pri.initFormByQo();

        JW.GeoC.locate();

        return false;
    };

    _pri.initEvs = function()
    {
        if (!_pri.inited)
        {
            _pri.page.on('geoc:set_name_to_ll_done', function(e, o) {
                _pri.dbg('on geoc:set_name_to_ll_done', o);
                _pri.loc_buff = o;
                _pri.$loc_inp.val(o.nm);

                _pri.getJobs();
            });

            _pri.page.on('geoc:set_ll_to_name_done', function(e, o) {
                _pri.dbg('on geoc:set_ll_to_name_done', o);
                _pri.loc_buff = o;
                _pri.$loc_inp.val(o.nm);

                _pri.getJobs();
            });

            _pri.page.on('sform:loading_jobs', function(e) {
                _pri.$sbtn.prop('disabled', true);
                _pri.$sbtn.html(_pri.sbtn_html_load);
            });

            _pri.page.on('sform:loading_jobs_done', function(e) {
                _pri.$sbtn.prop('disabled', false);
                _pri.$sbtn.html(_pri.sbtn_html);
            });

            _pri.page.on('modal:top_nav_shown', function(e) {
                _pri.$ffx.addClass('d-none');
            });

            _pri.page.on('modal:top_nav_hidden', function(e) {
                setTimeout(function() {
                    _pri.$ffx.removeClass('d-none');
                }, 300);
            });
        }

        _pri.$sbtn.on('click', function(e) {
            if (_pri.page.isPhoneMode() && _pri.$loc_inp.val() != '')
            {
                publ.ffxClick('#col-map');
            }
        });

        _pri.$loc_inp.on('change', _pri.onLocChange);
        _pri.$loc_inp.on('input', _pri.onLocInput);

        _pri.$lnk_locate.click(_pri.locate);
        _pri.$lnk_reset.click(_pri.resetForm);

        _pri.$frm.submit(_pri.formSubmit);
    };

    _pri.initFormByQo = function()
    {
        _pri.dbgG('*** initFormByQo()');

        var init_val;
        var old_val;

        // dist slider (not initialized yet)
        init_val = parseInt(_pri.qo.dist);
        if (init_val < 1 || init_val > 100)
        {
            init_val = _pri.opts.dist_start_val;
        }

        // if dist slider has been initialized
        if (_pri.dist_slider != null)
        {
            _pri.dist_slider.slider('setValue', init_val, false, true);
        }
        else
        {
            _pri.opts.dist_init_val = init_val;
        }

        // // hired
        // init_val = _pri.qo.emp_prof_hired;
        // old_val = _pri.$hired_inp.val();
        //
        // var pat = /^(?:07|08|02|)$/;
        // if (!pat.test(init_val))
        // {
        //     init_val = _pri.opts.hired_start_val;
        // }
        //
        // if (init_val != old_val)
        // {
        //     var $btn_new = _pri.$hired_btng.find('[data-val="' + init_val + '"]');
        //     var $btn_old = _pri.$hired_btng.find('[data-val="' + old_val + '"]');
        //     if (!_pri.inited_hired)
        //     {
        //         _pri.$hired_inp.val(init_val);
        //
        //         $btn_old.html('<h2>' + $btn_old.find('h1').html() + '</h2>');
        //         $btn_old.removeClass('btn-primary active');
        //         $btn_old.addClass('btn-secondary');
        //
        //         if ('' != init_val)
        //         {
        //             $btn_new.removeClass('btn-secondary');
        //             $btn_new.addClass('btn-primary active');
        //             $btn_new.html('<h1>' + $btn_new.find('h2').html() + '</h1>');
        //         }
        //     }
        //     else
        //     {
        //         if ('' != init_val)
        //         {
        //             $btn_new.click();
        //         }
        //         else
        //         {
        //             $btn_old.click();
        //         }
        //     }
        // }
        //
        // /*
        // // hired
        // var init_val = _pri.qo.emp_prof_hired;
        // var pat = /^(?:07|08|02|)$/;
        // if (!pat.test(init_val))
        // {
        //     init_val = _pri.opts.hired_start_val;
        // }
        //
        // var $btn = _pri.$hired_btng.find('[data-val="' + init_val + '"]');
        // var $btn_old = _pri.$hired_btng.find('.btn-primary.active');
        // //_pri.dbg('$btn_old', $btn_old);
        //
        // if (0 < $btn_old.length)
        // {
        //     $btn_old.html('<h2>' + $btn_old.find('h1').html() + '</h2>');
        // }
        //
        // var $cur_btn;
        // var $btns = _pri.$hired_btng.find('a');
        //
        // $.each($btns, function(k, v) {
        //     $cur_btn = $(v);
        //     if ($cur_btn.is($btn))
        //     {
        //         $cur_btn.removeClass('btn-secondary');
        //         $cur_btn.addClass('btn-primary active');
        //         $cur_btn.html('<h1>' + $cur_btn.find('h2').html() + '</h1>');
        //     }
        //     else
        //     {
        //         $cur_btn.removeClass('btn-primary active');
        //         $cur_btn.addClass('btn-secondary');
        //     }
        // });
        //
        // _pri.$hired_inp.val(init_val);
        // */
        //
        // // tags
        // var $sel_tags = $('#emp_tags');
        // if ('' != _pri.qo.emp_tags)
        // {
        //     var arr = _pri.qo.emp_tags.split(',');
        //     $.each(arr, function (i, tag) {
        //         var tag_dec = decodeURIComponent(tag);
        //         $sel_tags.append($('<option>', {
        //             value: tag_dec,
        //             text : tag_dec
        //         }));
        //     });
        //     $sel_tags.change();
        // }
        // else
        // {
        //     $sel_tags.find('option').remove().end();
        //     if (_pri.emp_tags_select != null)
        //     {
        //         //$sel_tags.trigger('jbselect:tags_changed');
        //         _pri.emp_tags_select.optionsChanged();
        //     }
        // }
        //
        // // advanced search
        // if ('' != _pri.qo.emp_prof1)
        // {
        //     var arr = _pri.qo.emp_prof1.split(',');
        //     $.each(arr, function (i, val) {
        //         _pri.$frm.find("input[type='checkbox'][name='emp_prof1'][value='" + val + "']").prop('checked', true);
        //     });
        // }
        //
        // // it's sufficient to clear emp_prof0 below ...
        // /*
        // else if (_pri.inited_advanced)
        // {
        //     _pri.$frm.find("input[type='checkbox'][name='emp_prof1']:checked").click();
        // }
        // */
        //
        // if ('' != _pri.qo.emp_prof0)
        // {
        //     var arr = _pri.qo.emp_prof0.split(',');
        //     $.each(arr, function (i, val) {
        //         _pri.$frm.find("input[type=checkbox][name='emp_prof0'][value='" + val + "']").prop('checked', true);
        //     });
        // }
        // else if (_pri.inited_advanced)
        // {
        //     _pri.$frm.find("input[type='checkbox'][name='emp_prof0']:checked").click();
        // }
        //
        // if (!_pri.inited_advanced)
        // {
        //     $('.adv-search input[type="checkbox"]').each(function() {
        //         var $this = $(this);
        //         var $panel = $this.closest('.panel');
        //         var $checked = $panel.find('input:checked');
        //         var len = $checked.length;
        //         var $lnk = $panel.find('h5.panel-title a');
        //         var txt = $lnk.text().replace(/ \(\d+\)$/, '');
        //         if (len > 0)
        //         {
        //             txt = txt + ' (' + len + ')';
        //             $lnk.addClass('hi');
        //             $panel.addClass('active');
        //             var $body = $panel.find('.acco-body').css('display', 'block');
        //             $checked = $panel.find('input[name="emp_prof1"]:checked');
        //             if ($checked.length > 0)
        //             {
        //                 $checked.each(function() {
        //                     var $cb = $(this);
        //                     var emp_prof0_val = $cb.val().substr(0, 2)
        //                     var $sub = $panel.find('[data-prof0="' + emp_prof0_val + '"]');
        //                     $sub.css('display', 'block');
        //                     var $cb_parent = $panel.find('input[value="' + emp_prof0_val + '"]');
        //                     $cb_parent.prop('checked', true);
        //                 });
        //             }
        //         }
        //         else
        //         {
        //             $lnk.removeClass('hi');
        //         }
        //         $lnk.text(txt);
        //     });
        // }
    };

    /*
    _pri.initScopeBtns = function()
    {
        var $btng = _pri.$frm.find('.scope-btns');
        var $btns = $btng.find('a');
        var $scope_inp = _pri.$frm.find('input[name="job_scope"]');

        $btns.on('click', function(e) {
            e.preventDefault();
            _pri.dbg('btns click');
            var val_old = $scope_inp.val();
            var $btn_old = $btng.find('[data-val="' + val_old + '"]');
            //_pri.dbg('$btn_old', $btn_old);
            var $btn = $(this);
            var val = $btn.data('val');
            if (val != val_old)
            {
                _pri.dbg('val != oval');
                $scope_inp.val(val);

                $btn_old.html('<h2>' + $btn_old.text() + '</h2>');

                var $cur_btn;
                $.each($btns, function(k, v) {
                    $cur_btn = $(v);
                    if ($cur_btn.is($btn))
                    {
                        $cur_btn.removeClass('btn-secondary');
                        $cur_btn.addClass('btn-primary active');
                        $cur_btn.html('<h1>' + $cur_btn.text() + '</h1>');
                    }
                    else
                    {
                        $cur_btn.removeClass('btn-primary active');
                        $cur_btn.addClass('btn-secondary');
                    }
                });
                _pri.getJobs();
            }
        });
    };
    */

    _pri.initHiredBtns = function()
    {
        if (_pri.inited_hired)
        {
            return false;
        }

        _pri.inited_hired = true;

        var $btns = _pri.$hired_btng.find('a');

        var is_exclusive = true;

        $btns.on('click', function(e) {
            var $btn = $(this);
            var val = $btn.data('val');
            if ('01' == val)
            {
                return true;
            }

            e.preventDefault();
            _pri.dbg('hired btns click');

            if (is_exclusive)
            {
                var val_old = _pri.$hired_inp.val();
                var $btn_old = _pri.$hired_btng.find('[data-val="' + val_old + '"]');
                //_pri.dbg('$btn_old', $btn_old);

                if (val != val_old)
                {
                    _pri.dbg('val != oval');
                    _pri.$hired_inp.val(val);

                    $btn_old.html('<h2>' + $btn_old.find('h1').html() + '</h2>');

                    var $cur_btn;
                    $.each($btns, function(k, v) {
                        $cur_btn = $(v);
                        if ($cur_btn.is($btn))
                        {
                            $cur_btn.removeClass('btn-secondary');
                            $cur_btn.addClass('btn-primary active');
                            $cur_btn.html('<h1>' + $cur_btn.find('h2').html() + '</h1>');
                        }
                        else
                        {
                            $cur_btn.removeClass('btn-primary active');
                            $cur_btn.addClass('btn-secondary');
                        }
                    });
                }
                else
                {
                    $btn.removeClass('btn-primary active');
                    $btn.addClass('btn-secondary');
                    $btn.html('<h2>' + $btn.find('h1').html() + '</h2>');

                    _pri.$hired_inp.val('');
                }
            }
            else
            {
                var vals = [];

                var $btn = $(this);

                if ($btn.hasClass('active'))
                {
                    $btn.html('<h2><i class="fa fa-fw" aria-hidden="true"></i> <span>' + $btn.find('h1 span').html() + '</span></h2>');
                    $btn.removeClass('btn-primary active');
                    $btn.addClass('btn-secondary');
                }
                else
                {
                    $btn.html('<h1><i class="fa fa-fw fa-pull-left fa-check" aria-hidden="true"></i> <span>' + $btn.find('h2 span').html() + '</span></h1>');
                    $btn.removeClass('btn-secondary');
                    $btn.addClass('btn-primary active');
                }

                $.each($btns, function(k, v) {
                    $cur_btn = $(v);
                    if ($cur_btn.hasClass('active'))
                    {
                        vals.push($cur_btn.data('val'));
                    }
                });

                _pri.$hired_inp.val(vals.join(','));
            }

            _pri.getJobs();
        });
    };

    _pri.initTagsSelect = function()
    {
        _pri.emp_tags_select = JW.JBSelect(jQuery, document.getElementsByClassName("jb-select emp_tags"));
        _pri.emp_tags_select.on('jbselect:tags_changed', function(e) {
            _pri.dbg('******** emp_tags on jbselect:tags_changed');
            _pri.getJobs();
        });
    };

    _pri.initAdvSearch = function()
    {
        if (_pri.inited_advanced)
        {
            return;
        }

        _pri.inited_advanced = true;

        $("input[name^='emp_prof0']").click(_pri.emp_prof_0_clicked);

        $('.adv-search input[type="checkbox"]').on('change', function(e) {
            var $this = $(this);
            var $panel = $this.closest('.panel');
            var len = $panel.find('input:checked').length;
            var $lnk = $panel.find('h5.panel-title a');
            var txt = $lnk.text().replace(/ \(\d+\)$/, '');
            if (len > 0)
            {
                txt = txt + ' (' + len + ')';
                $lnk.addClass('hi');
            }
            else
            {
                $lnk.removeClass('hi');
            }
            $lnk.text(txt);

            _pri.getJobs();
        });
    };

    _pri.initDistSlider = function()
    {
        //$("#qd").on("slide", $.throttle(16, _pri.distOnSlide));
        //_pri.$dist_inp.on("slide", _pri.distOnSlide);

        _pri.$dist_inp.on("change", function(e) {
            //_pri.dbg('######## dist on change', e);
            if (_pri.dist_buff != e.value.newValue)
            {
                //_pri.dbg('    ########');
                $("#qd-lbl").text('Umkreis ' + e.value.newValue + ' Kilometer');
                JW.Map.showCircleDist(e.value.newValue);
                _pri.dist_buff = e.value.newValue;
            }
        });

        _pri.$dist_inp.on("slideStop", function(e) {
            //_pri.dbg('######## dist on slideStop', e);
            JW.Map.setCircleDist(e.value);
            if (_pri.loc_buff && typeof _pri.loc_buff === 'object' && _pri.loc_buff.hasOwnProperty('nm'))
            {
                if (_pri.loc_buff.nm == _pri.$loc_inp.val())
                {
                    _pri.getJobs();
                }
                else
                {
                    _pri.dbg('!!! unhandled case!');
                }
            }
            else if (JW.Page.hasMap())
            {
                var ll = JW.Map.getMapCenter();
                JW.GeoC.getNameToLL(ll);
            }
        });

        _pri.dist_slider = _pri.$dist_inp.slider({
            formatter: function(value) {
                return 'Radius: ' + value + ' Kilometer';
            },
            min: 1,
            max: 100,
            step: 1,
            value: 1,
            tooltip: 'hide'
        }).slider('setValue', _pri.opts.dist_init_val, false, true); // fn, val, trigger slide ev, trigger change ev

        //_pri.$dist_inp.change();
    };

    // not used anymore, will use on change instead to take also clicks into accout
    _pri.distOnSlide = function(e)
    {
        //_pri.dbg('distOn slide');
        if (_pri.dist_buff != e.value)
        {
            //_pri.dbg('    ########');
            $("#qd-lbl").text('Umkreis ' + e.value + ' Kilometer');
            JW.Map.showCircleDist(e.value);
            _pri.dist_buff = e.value;
        }
    };

    _pri.initFfx = function()
    {
        _pri.dbgG('*** initFfx()');

        _pri.$ffx = $('#nav-ffx');
        var $as = _pri.$ffx.find('a');
        $as.on('click', function(e) {
            e.preventDefault();
            var colid = $(this).data('colid');
            publ.ffxClick(colid);
            return false;
        });
    };

    publ.ffxClick = function(colid, cb)
    {
        _pri.dbgG('*** ffxClick(' + colid + ')');

        if (colid == '#col-left')
        {
            publ.showCol(true);
            JW.Map.showCol(false);
            JW.MapList.showCol(false);
        }
        else if (colid == '#col-map')
        {
            _pri.dbg('    colid: #col-map');
            publ.showCol(false);
            JW.Map.showCol(true);
            JW.MapList.showCol(false);
            _pri.dbg('    --------');
        }
        else if (colid == '#col-right')
        {
            publ.showCol(false);
            JW.Map.showCol(false);
            JW.MapList.showCol(true);
        }
        else
        {
            _pri.dbg('!!! unkown col!');
        }

        var $as = _pri.$ffx.find('a');
        $.each($as, function(k, v) {
            var $a = $(this);
            if ($a.data('colid') == colid)
            {
                $a.removeClass('text-primary');
                $a.addClass('text-muted active');
            }
            else
            {
                $a.removeClass('text-muted active');
                $a.addClass('text-primary');
            }
        });
    };

    publ.showCol = function(bool)
    {
        _pri.dbgG('*** showCol(' + bool + ')');
        _pri.dbg('h1111111111111111111111 ??????????????????????????????????');

        if (!_pri.$col)
        {
            return;
        }

        _pri.dbg('22222222222222222222222 ??????????????????????????????????');

        if (bool)
        {
            _pri.$col.removeClass('d-none');
        }
        else
        {
            _pri.$col.addClass('d-none');
        }
    };

    _pri.onLocChange = function(e)
    {
        _pri.dbg('******** onLocChange()');
        //var locstr = $(this).val();
        //_pri.dbg(locstr, escape(locstr), encodeURIComponent(locstr));
    };

    _pri.onLocInput = function(e)
    {
        _pri.dbg('******** onLocInput()');
        //var locstr = $(this).val();
        //_pri.dbg(locstr, escape(locstr), encodeURIComponent(locstr));
    };

    _pri.emp_prof_0_clicked = function(e)
    {
        //_pri.dbg('******** emp_prof_0_clicked() val:', this.value);
        var $sub = _pri.$frm.find('[data-prof0="' + this.value + '"]');
        if (this.checked)
        {
            $sub.stop( true, true ).slideDown('300', 'swing');
        }
        else
        {
            $sub.find('input[type="checkbox"]').prop('checked', false )
            $sub.stop( true, true ).slideUp('300', 'swing');
        }
    };

    _pri.extend();

    // expose public methods
    return publ;
})(jQuery);
